import type { IntlShape } from "react-intl";
import { defineMessages } from "react-intl";

const roomTypeMessages = defineMessages({
  fullVenue: {
    defaultMessage: "full venue",
  },
  privateRoom: {
    defaultMessage: "private room",
  },
  reservedArea: {
    defaultMessage: "reserved area",
  },
  semiPrivateRoom: {
    defaultMessage: "semi-private room",
  },
});

/**
 * Localizes a listing room-type id for FSV space-rental labels.
 */
export const getRoomTypeLabel = (
  roomType: string | null | undefined,
  intl: IntlShape,
): string => {
  if (!roomType) {
    return intl.formatMessage(roomTypeMessages.reservedArea);
  }

  switch (roomType) {
    case "full_space_buyout":
      return intl.formatMessage(roomTypeMessages.fullVenue);
    case "private_room":
      return intl.formatMessage(roomTypeMessages.privateRoom);
    case "semi_private_room":
      return intl.formatMessage(roomTypeMessages.semiPrivateRoom);
    default:
      return intl.formatMessage(roomTypeMessages.reservedArea);
  }
};
